import { createTheme } from '@material-ui/core/styles';
import KenColors from './KenColors';
import { typography } from './base-theme';

export const overridings = {
  // for RTL
  // direction: 'rtl',
  name: 'Light Theme',
  KenColors,
  palette: {
    KenColors,
    primary: {
      light: KenColors.neutral700,
      main: KenColors.primary,
      dark: KenColors.neutral900,
      contrastText: '#fff',
    },
    secondary: {
      light: KenColors.shadowColor,
      main: KenColors.primary,
      dark: KenColors.secondaryPrime,
      contrastText: '#fff',
    },
  },
  typography,
};

export const createLightTheme = (customization) => {
  const overrideTheme = {
    name: 'Light Theme',
    KenColors: { ...KenColors, ...(customization?.palette || {}) },
    palette: {
      KenColors,
      primary: {
        light: KenColors.neutral700,
        main: KenColors.primary,
        dark: KenColors.neutral900,
        contrastText: '#fff',
      },
      type: 'light',
      secondary: {
        light: KenColors.shadowColor,
        main: KenColors.primary,
        dark: KenColors.secondaryPrime,
        contrastText: '#fff',
      },
    },
    typography,
  };
  return createTheme(overrideTheme);
};

export default createTheme(overridings);
